import { Box, Divider, Heading, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import wbAPIKeyGenerationImage from '../../../../assets/img/wb_api_key_page.png';
import wbI9ConfigureImage from '../../../../assets/img/wb_i9_configure_page.png';
import wbWebhookCreationImage from '../../../../assets/img/wb_webhook_page.png';
import colors from '../../../../styles/colors';

export const I9Turtorial = (): JSX.Element => {
  const { t } = useTranslation('i9Verification');

  return (
    <Box>
      <Box px={6} py={4}>
        <Heading as="h3" fontSize="md" lineHeight="1.3" mb={1}>
          {t('i9SetupLabel')}
        </Heading>
        <Text fontSize="xs" color="gray.500">
          {t('setupStep')}
        </Text>
      </Box>
      <Divider borderColor={colors.gray[50]} />
      <Box p={6}>
        <Box mb={3}>
          <Heading as="h5" fontSize="sm" lineHeight={1}>
            {t('finalNote')}
          </Heading>
        </Box>

        <Box mb={10}>
          <Heading as="h5" fontSize="sm">
            {t('apiGenerationTitle')}
          </Heading>
          <Text mb="15px" fontSize="sm">
            {`1. ${t('stepGenerateWorkBrightAPIKey')}`}
          </Text>
          <Box mb={4} textAlign="center">
            <Box
              as="img"
              src={wbAPIKeyGenerationImage}
              alt="I-9 Configuration"
              maxW="900px"
              w="100%"
              borderRadius="md"
              boxShadow="md"
              border="1px solid"
              borderColor="gray.200"
            />
          </Box>
          <Text mb="5px" fontSize="sm">
            {`2. ${t('stepCopyAPIKey')}`}
          </Text>
        </Box>

        <Box mb={10}>
          <Heading as="h5" fontSize="sm">
            {t('webHookGenerationTitle')}
          </Heading>
          <Text mb="15px" fontSize="sm">
            {`1. ${t('stepGenerateWorkBrightWebhook1')}`}
          </Text>
          <Box mb={4} textAlign="center">
            <Box
              as="img"
              src={wbWebhookCreationImage}
              alt="I-9 Configuration"
              maxW="900px"
              w="100%"
              borderRadius="md"
              boxShadow="md"
              border="1px solid"
              borderColor="gray.200"
            />
          </Box>
          <Text mb="5px" fontSize="sm">
            {`2. ${t('stepGenerateWorkBrightWebhooks2')}`}
          </Text>
        </Box>

        <Box mb={10}>
          <Heading as="h5" fontSize="sm">
            {t('i9ConfigurationTitle')}
          </Heading>
          <Text mb="15px" fontSize="sm">
            {`${t('stepCopyWBCredentials')}`}
          </Text>
          <Box mb={4} textAlign="center">
            <Box
              as="img"
              src={wbI9ConfigureImage}
              alt="I-9 Configuration"
              maxW="900px"
              w="100%"
              borderRadius="md"
              boxShadow="md"
              border="1px solid"
              borderColor="gray.200"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
